import { organisationConstants } from '../../../_constants/organisation.constants';

const initialState = { uploaded_assessment_responses_result_list_loading : true, uploaded_assessment_responses_result_list_data: '', uploaded_assessment_responses_result_list_error_data : '', uploaded_assessment_responses_result_list_error: false};

export function uploadAssessmentResponsesResultList(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_UPLOAD_ASSESSMENT_RESPONSES_RESULT_LIST_API:
        return {
            uploaded_assessment_responses_result_list_loading: true,
            uploaded_assessment_responses_result_list_data: '',
            uploaded_assessment_responses_result_list_error_data: '',
            uploaded_assessment_responses_result_list_error: false
        };
      case organisationConstants.RECIEVE_UPLOAD_ASSESSMENT_RESPONSES_RESULT_LIST_API:
        return {
            uploaded_assessment_responses_result_list_loading: false,
            uploaded_assessment_responses_result_list_data: action.uploaded_assessment_responses_result_list.data,
            uploaded_assessment_responses_result_list_error_data: '',
            uploaded_assessment_responses_result_list_error: false
        };
      case organisationConstants.ERROR_UPLOAD_ASSESSMENT_RESPONSES_RESULT_LIST_API:
        return { 
            uploaded_assessment_responses_result_list_loading: false,
            uploaded_assessment_responses_result_list_data: '',
            uploaded_assessment_responses_result_list_error_data: action.error.response.data.message,
            uploaded_assessment_responses_result_list_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/uploadCsv/uploadAssessmentResponsesResultList.reducer.js